import React from "react";
import { Link } from "react-router-dom";
import { button } from "components/designTokens";
import * as icons from "components/icons";
import c from "classnames";
import { env } from "const";

export function Shelf({
  highlights,
  reorderHighlights,
  showReorder,
  onDeleteHighlight,
  onReorderClick,
  onReorderCancelClick,
  onUpOrderClick,
  onDownOrderClick,
  onSaveOrderClick,
}) {
  return (
    <div className="mt-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-lg leading-6 font-medium text-gray-900">
            Program Shelf
          </h1>
          <p className="max-w-4xl text-sm leading-5 text-gray-500">
            Displays on program page. The "TOP Highligh" is displayed on the top
            of the page.
          </p>
        </div>
        <Link
          to="/highlight"
          className={`inline-flex items-center px-4 py-2 text-sm leading-5 font-medium ${button.primary}`}
        >
          Create Program Shelf
        </Link>
      </div>

      <div className="bg-white border mt-4 overflow-hidden shadow sm:rounded-md">
        <div className="block">
          <div className="px-4 py-4 flex items-center sm:px-6">
            <div className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
              <div>
                <div className="text-sm leading-5 font-medium text-indigo-600 truncate">
                  TOP Highlight
                  <span className="ml-1 font-normal text-gray-500"></span>
                </div>
              </div>
              <div className="mt-4 flex-shrink-0 sm:mt-0"></div>
            </div>
            <div className="flex flex-shrink-0 ml-5">
              <Link
                to={`/highlight/${env.TOP_HIGHLIGHT_ID}`}
                className="bg-orange-500 text-white rounded-full p-1 hover:bg-orange-400 cursor-pointer focus:outline-none active:outline-none"
              >
                <icons.Pen size={4}></icons.Pen>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {!showReorder && (
        <div className="mt-8">
          <button
            onClick={onReorderClick}
            className="px-2 py-1 border text-gray-500 text-xs rounded"
          >
            Reorder Shelf
          </button>
        </div>
      )}
      <div className="bg-white border shadow overflow-hidden sm:rounded-md mt-4">
        <div>
          {!showReorder &&
            highlights
              .sort((a, b) => {
                return a.rank - b.rank;
              })
              .map((h, i) => (
                <Row
                  key={h.id}
                  index={i}
                  {...h}
                  onDeleteHighlight={onDeleteHighlight}
                />
              ))}
          {showReorder &&
            reorderHighlights
              .sort((a, b) => {
                return a.rank - b.rank;
              })
              .map((h) => (
                <ReorderRow
                  key={h.id}
                  highlight={h}
                  onUpOrderClick={onUpOrderClick}
                  onDownOrderClick={onDownOrderClick}
                  onD
                />
              ))}
          {showReorder && (
            <div className="flex justify-end p-4">
              <span className="inline-flex rounded-md shadow-sm">
                <button
                  onClick={onReorderCancelClick}
                  className="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
                >
                  Cancel
                </button>
              </span>
              <span className="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  type="button"
                  className={c(
                    "inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md focus:outline-none bg-orange-500 hover:bg-orange-400 text-white focus:border-orange-600 focus:shadow-outline-orange active:bg-orange-600 transition duration-150 ease-in-out"
                  )}
                  onClick={onSaveOrderClick}
                >
                  Save Order
                </button>
              </span>
            </div>
            // <div className="mt-4">
            //   <div className="flex justify-between">
            //     <button
            //       onClick={onReorderCancelClick}
            //       className="text-lg font-semibold underline text-gray-500"
            //     >
            //       Cancel
            //     </button>
            //     <button
            //       onClick={onSaveOrderClick}
            //       className={`inline-flex items-center px-4 py-2 text-sm leading-5 font-medium ${button.primary}`}
            //     >
            //       Save Order
            //     </button>
            //   </div>
            // </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Row({ id, title, onDeleteHighlight, index }) {
  return (
    <div className={c("block", { "border-t": index > 0 })}>
      <div className="px-4 py-4 flex items-center sm:px-6">
        <div className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <div className="text-sm leading-5 font-medium text-indigo-600 truncate">
              {title}
              <span className="ml-1 font-normal text-gray-500"></span>
            </div>
          </div>
          <div className="mt-4 flex-shrink-0 sm:mt-0"></div>
        </div>
        <div className="flex flex-shrink-0 ml-5">
          <Link
            to={`/highlight/${id}`}
            className="mr-1 bg-orange-500 text-white rounded-full p-1 hover:bg-orange-400 cursor-pointer focus:outline-none active:outline-none"
          >
            <icons.Pen size={4}></icons.Pen>
          </Link>
          {id !== env.TOP_HIGHLIGHT_ID && (
            <button
              onClick={(e) => {
                e.preventDefault();
                onDeleteHighlight(id);
              }}
              className="bg-orange-500 text-white rounded-full p-1 hover:bg-orange-400 cursor-pointer focus:outline-none active:outline-none"
            >
              <icons.Rubbish size={4}></icons.Rubbish>
            </button>
          )}
        </div>
      </div>
      {/* <div className="flex justify-between">
        <span className="text-lg font-semibold">{title}</span>
        <div className="flex">
          <Link
            to={`/highlight/${id}`}
            className="bg-orange-500 text-white rounded-full p-1 hover:bg-orange-400 cursor-pointer focus:outline-none active:outline-none"
          >
            <Pen></Pen>
          </Link>
          {id !== env.TOP_HIGHLIGHT_ID && (
            <button
              onClick={(e) => {
                e.preventDefault();
                onDeleteHighlight(id);
              }}
              className="ml-1 inline-block bg-orange-500 text-white rounded-full p-2 hover:bg-orange-400 cursor-pointer focus:outline-none active:outline-none"
            >
              <Rubbish size={4}></Rubbish>
            </button>
          )}
        </div>
      </div> */}
    </div>
  );
}

function ReorderRow({ highlight, onUpOrderClick, onDownOrderClick }) {
  return (
    <div className="border-b text-gray-500 p-4">
      <div className="flex items-center">
        <button
          onClick={(e) => {
            e.preventDefault();
            onUpOrderClick(highlight, highlight.rank - 1);
          }}
          className="text-gray-900 mr-1 cursor-pointer hover:text-orange-500 transition duration-150 ease-in-out focus:outline-none active:outline-none"
        >
          <icons.ArrowCircleUp size={4}></icons.ArrowCircleUp>
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            onDownOrderClick(highlight, highlight.rank + 1);
          }}
          className="text-gray-900 mr-4 cursor-pointer hover:text-orange-500 transition duration-150 ease-in-out focus:outline-none active:outline-none"
        >
          <icons.ArrowCircleDown size={4}></icons.ArrowCircleDown>
        </button>
        <span className="text-sm leading-5 font-medium text-indigo-600 truncate">
          {highlight.title}
        </span>
      </div>
    </div>
  );
}
